import type { GeneratorReadiness } from './types';

// How a generated document comes to be, in a sentence, for the places that offer
// to generate one.
export function generationNote(g: Pick<GeneratorReadiness, 'kind' | 'byline'>): string {
    if (g.kind === 'draft') {
        return `Written as a draft by ${g.byline ?? 'Navaris'} from your company's record, with gaps and unchecked figures highlighted for you to complete. Drafted again only when you ask.`;
    }
    return g.byline
        ? `Built from your company's knowledge and kept up to date as it changes, with commentary by ${g.byline}.`
        : "Built from your company's knowledge and kept up to date as it changes.";
}

export function generateLabel(g: Pick<GeneratorReadiness, 'kind' | 'file_id'>): string {
    if (g.kind === 'draft') return g.file_id ? 'Redraft' : 'Draft';
    return g.file_id ? 'Regenerate' : 'Generate';
}
